<template>
  <div>
    <!-- Filters -->
    <ReportsListFilters
      :date-filter.sync="dateFilter"
      :dealer-options="dealerListSelect"
      :dealer-filter.sync="dealerFilter"
    />

    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >

      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Показ</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>строка</label>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Поиск..."
              />
            </div>
          </b-col>
        </b-row>

      </div>

      <b-table
        ref="refReportsListTable"
        class="position-relative"
        :items="fetchReports"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="Ничего не найдено"
        :sort-desc.sync="isSortDirDesc"
      >

        <!-- Column: packet -->
        <template #cell(packet)="data">
          <div class="text-nowrap">
            <span class="align-text-top text-capitalize">{{ data.item.packet }}</span>
          </div>
        </template>

        <!-- Column: count -->
        <template #cell(count)="data">
          <div class="text-nowrap">
            <span class="align-text-top text-capitalize">{{ data.item.count }}</span>
          </div>
        </template>

      </b-table>
      <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Показано {{ dataMeta.from }} до {{ dataMeta.to }} из {{ dataMeta.of }} строк</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="totalReports"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BTable, BPagination,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import ReportsListFilters from '@/views/admin/report/ReportsListFilters.vue'
import useReportsList from './useReportsList'

export default {
  data() {
    return {
      selectedId: 0,
      dealerListSelect: [],
      url: '',
    }
  },
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BTable,
    BPagination,
    vSelect,
    ReportsListFilters,
  },
  methods: {
    dealerList() {
      const that = this
      this.$http.get(`${this.url}/api/dealer/list`, {}, {}).then(response => {
        const dataDealer = response.data
        that.dealerListSelect = []
        Object.keys(dataDealer).forEach(key => {
          const d = dataDealer[key]
          that.dealerListSelect.push(
            {
              title: `${d}`,
              value: `${key}`,
            },
          )
        })
        if (that.dealerListSelect.length === 1) {
          that.dealerFilter = that.dealerListSelect[0].value
        }
      }).catch()
    },
  },
  created() {
    this.url = 'https://tojtel.tj'
    this.dealerList()
  },
  setup() {
    const {
      fetchReports,
      tableColumns,
      perPage,
      currentPage,
      totalReports,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refReportsListTable,
      refetchData,
      dateFilter,
      dealerFilter,
    } = useReportsList()

    return {
      fetchReports,
      tableColumns,
      perPage,
      currentPage,
      totalReports,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refReportsListTable,
      refetchData,
      dateFilter,
      dealerFilter,
    }
  },
}
</script>

<style>
.per-page-selector {
  width: 90px;
}
.flatpickr-calendar .flatpickr-day.inRange, .flatpickr-calendar .flatpickr-day.inRange:hover {
  -webkit-box-shadow: -5px 0 0 #f3f2fe, 5px 0 0 #f3f2fe;
  box-shadow: -5px 0 0 #f3f2fe, 5px 0 0 #f3f2fe;
}
.flatpickr-calendar .flatpickr-day.inRange, .flatpickr-calendar .flatpickr-day.inRange:hover {
  background: #f3f2fe;
  border-color: #f3f2fe;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
